export const DUTCHIE = "dutchie";
export const METRC = "metrc";
export const ALPINEIQ = "alpineiq";
export const IDSCAN = "idscan";

export const INTEGRATIONS = [
    DUTCHIE, METRC, ALPINEIQ, IDSCAN
];

export const getMetrcStripeIds = () => {
    if (process.env.USE_LIVE_STRIPE_ACCOUNT || process.env.REACT_APP_USE_LIVE_STRIPE_ACCOUNT) {
        return {
            stripe_product_external_id: "prod_Sti5tRF1yAdQ6h",
            stripe_price_external_id: "price_1RyH03CEhkWRjCsPc6hBehvk",
        }
    } else {
        return {
            stripe_product_external_id: "prod_Su5AYrWxqrdKYj",
            stripe_price_external_id: "price_1RyH03CEhkWRjCsPc6hBehvk",
        }
    }
}

export const getDutchieStripeIds = () => {
    if (process.env.USE_LIVE_STRIPE_ACCOUNT || process.env.REACT_APP_USE_LIVE_STRIPE_ACCOUNT) {
        return {
            stripe_product_external_id: "prod_SRz28N4DN0uMNe",
            stripe_price_external_id: "price_1RX54WFy88bsb57ujNsJGliK",
        }
    } else {
        return {
            stripe_product_external_id: "prod_SRyrZy5oFWcPGm",
            stripe_price_external_id: "price_1RX4tICEhkWRjCsPwSdVD4Jq",
        }
    }
}